<template lang="">
	<div>
		<div>
			<!-- 副导航 -->
			<c-r-m-nav-cell
				ref="navcell" 
				:crm-type="crmType" 
				route-type="index"/>
				
			<!-- 筛选 -->	
			<div class="shitu-box">
				<c-r-m-list-head
					ref="listHead" 
					:crm-type="crmType" 
					:actiontype="actiontype"
					:scene_id="scene_id"
					@on-handle="listHeadHandle"/>
				
				<c-r-m-option-button
					ref="search" 
					:crm-type="crmType" 
					:searchtype="searchtype"
					:actiontype="actiontype"
					:exporttype="exporttype"
					:filter-arr="filterArr"
					:scene_id="scene_id"
					@on-handle="optionHandle"
					@save-handle="saveHandle"
					@on-search="searchHandle"
					@on-height-search="heightSearchHandle"/>	
			</div>
			
			<!-- 信息 -->
			<div v-loading="loading" class="abctable">
				<c-r-m-table-head
					ref="crmTableHead"
					:crm-type="crmType"
					:show-hegiht-search="true"
					:actiontype="actiontype"
					@exportData="exportData"
				    @filter="handleFilter"
					@handle="handleHandle">
				</c-r-m-table-head>
				<el-table
					v-show="!loading"
					id="crm-table"
					:data="list" 
					class="n-table--border"
					:cell-style="cellStyle"
					stripe
					border
					size="mini"
					style="width: 100%"
					:header-cell-style="{'background-color':'#f6faff'}" 
					@row-click="handleRowClick"
					@sort-change="sortChange"
					@selection-change="handleSelectionChange">
					<template slot="empty"> 
						<el-empty 
							description="暂无数据"></el-empty>
					</template>
					<el-table-column
						v-if="fieldList.length > 0"
						show-overflow-tooltip
						type="selection"
						align="center"
						width="45"/>
					<el-table-column
						v-for="(item, index) in fieldList"
						v-if="item.prop == 'name'"
						:key="index"
						:prop="item.prop"
						:label="item.label"
						:formatter="fieldFormatter"
						sortable="custom">
					</el-table-column>
					<el-table-column
						v-else-if="item.prop == 'finance_type'"
						:key="index"
						:prop="item.prop"
						:label="item.label"
						:formatter="fieldFormatter"
						width="105"
						show-overflow-tooltip
						sortable="custom"
						:width="item.width">
						<template slot-scope="scope">
							<el-tag style="width: 70px;" v-if="scope.row['finance_type'] == '1'" type="warning" effect="light">非诉服务</el-tag>
							<el-tag style="width: 70px;" v-else-if="scope.row['finance_type'] == '2'" type="success" effect="light">非诉咨询</el-tag>
							<el-tag style="width: 70px;" v-else-if="scope.row['finance_type'] == '3'" effect="light">案件收费</el-tag>
							<el-tag style="width: 70px;" v-else-if="scope.row['finance_type'] == '4'" type="danger" effect="light">顾问收费</el-tag>
							<el-tag style="width: 70px;" v-else effect="light">{{ scope.row['status'] }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column
						v-else
						:key="index"
						:prop="item.prop"
						:label="item.label"
						:formatter="fieldFormatter"
						sortable="custom">
						<template
						  slot="header"
						  slot-scope="scope">
						  <div class="table-head-name">{{ scope.column.label }}</div>
						</template>
					</el-table-column>
					<!-- 操作 -->
					<el-table-column
						align="center"
						label="操作"
						width="55"
						v-if="fieldList.length > 0">
							<template slot-scope="scope">
								<el-link
									type="primary"
									v-if="allAuth.lawcase && allAuth.lawcase.read"
									@click="handleAction({'type':'read','data':scope.row})">查看</el-link>
								<el-link
									type="primary"
									v-if="allAuth.lawcase &&allAuth.lawcase.update_finance"
									@click="handleAction({'type':'update','data':scope.row})">修改</el-link>
								<el-link
									type="primary"
									v-if="allAuth.lawcase && allAuth.lawcase.confirm_finance  && scope.row.confirm_time == 0"
									@click="handleAction({'type':'confirm','data':scope.row})">审核</el-link>
							</template>
					</el-table-column>
				</el-table>
				<div class="p-contianer" v-if="!loading">
					<div class="huizong">当前页面金额总计：<span style="color: red;">{{money}}</span> 元，所有金额总计：<span style="color: red;">{{sum_money}}</span> 元</div>
					<el-pagination 
						:current-page="currentPage"
						:page-sizes="pageSizes"
						:page-size.sync="pageSize"
						:total="total"
						class="p-bar"
						layout="total, sizes, prev, pager, next, jumper"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"/>
				</div>
			</div>
		</div>
		<!-- dialog弹窗 -->
		<dialog-form
			:dialog-visible="dialogForm"
			:title="title"
			ref="crmform"  
			:crm-type="crmType"
			:fields-data = "fieldsData"
			:action="action"
			:form-data="formData"
			@close = "closeDialog"
			@save-dialog="saveDialog">
		</dialog-form>
	</div>
</template>
<script>
	import { mapGetters } from 'vuex'
	import table from '../../mixins/finance'
	import {DialogForm} from '@/components/FromData'
	export default {
		name: "app",
		components: {
			DialogForm
		},
		mixins: [table],
		data() {
			return {
				crmType: 'finance',
				actiontype:7,
				searchtype:15,
				exporttype:25
				
			}
		},
		computed: {
			...mapGetters(['allAuth'])
		},
		methods: {
			/** 通过回调控制style */
			cellStyle({ row, column, rowIndex, columnIndex }) {
			  if (column.property === 'customer') {
			    return { color: '#3E84E9', cursor: 'pointer' }
			  }else if (column.property === 'confirm_time') {
			    return { color: '#e70000', cursor: 'pointer' }
			  } else {
			    return ''
			  }
			},
			
			handleAction(item){
				let items = {}
				switch (item.type){
					case "read":
						if(item.data.finance_type == "4"){
							this.$router.push({
								path:"/contract/read/finance/"+item.data.action_id
							}) 
						}else{
							this.$router.push({
								path:"/lawcase/read/finance/"+item.data.action_id
							}) 
						}
						break;
						
					case "confirm":
						this.title = "审批收款"
						this.action = { type: 'update',relevant:'confirmfinance' ,actiontype:11}
						this.formData["id"] = item.data.id
						this.dialogForm = true
						break;
						
					case "update":
						this.title = "修改收款"
						this.action = { type: 'update',relevant:'finance' ,actiontype:12 }
						items = JSON.parse(JSON.stringify(item.data))
						let filter = this.$options.filters['filterTimestampToFormatTime']
						items['f_time'] = filter(items['f_time'])
						this.formData = items
						this.dialogForm = true
						break;
				}
			}
		}
	}
</script>
<style scoped>
	.shitu-box {
		margin-top: 10px;
		padding: 10px;
		background-color: #fff;
		width: 1200px;
		font-size: 15px;
	}
	
	/deep/ .p-contianer{
		background-color: #fff !important;
		padding:10px;
		display: flex;
		justify-content: space-between;
	}
	/deep/ .table-head-name{
		display: inline;
	}
	/deep/ .el-table  {
	  overflow: visible;
	}
	 
	/deep/ .el-table__header-wrapper {
	  position: sticky;
	  top: 50px;
	  z-index: 10;
	}
	.icon, .customer-lock{
		cursor: pointer;
		font-size: 15px;
	}
	.customer-lock {
		color: #f15e64;
	}
	.huizong {
	    margin-top: 8px;
	    padding: 2px 15px;
	    height: 28px;
	    line-height: 28px;
		font-size: 13px !important;
	}
	.p-bar {
	    float: right;
	    margin: 5px 100px 0 0;
	    
	}
	/deep/ .el-link{
		font-size: 12px !important;
	}
	.heise{
		color:#333 !important;
	}
	/deep/ .el-tag{
		/* color:#333 !important; */
		/* width: 85px !important; */
		overflow: hidden;
		text-align: center;
		padding:0 !important
	}
	/deep/ .el-table .el-table__cell {
	    padding: 3px 0 !important;
	}
</style>